import { useState, useEffect, useRef, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import { FaFileExport } from "react-icons/fa"
import { toast } from 'react-toastify'
import Server from "../../Shared/Server"
import Spinner from '../../Shared/Spinner'
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import AsyncSelectField from "../../Shared/AsyncSelect";


const TechnicianTodos = () => {
    const [todos, setTodos] = useState([])
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [title, setTitle] = useState('All Pending Todo')
    const [technicainOptions, setTechnicainOptions] = useState([])
    const gridRef = useRef();
    const [formData, setFormData] = useState({
        technician_id: "",
    })
    const {technician_id} = formData

    const navigate = useNavigate()

    useEffect(() => {

        fetchData({technician_id})
    }, [])

    const loadOptions = async (url, query, setOptions) => {
        const params = { q: query };
        try {
            const response = await Server.get(`/options/${url}`, {params});
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const columnDefs = useMemo(() => [
        {
            headerName: "#",
            filter: false,
            maxWidth: 70,
            sortable: true,
            valueFormatter: function (params) {
            if (isNaN(params.node.id)) {
                return "";
            }
            return `${Number(params.node.rowIndex) + 1}`;
            },
        },

        {
            headerName: "Date",
            field: "date",
            sortable: true,
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (filterDate, cellValue) => {
                  const cellDate = new Date(cellValue);
                  cellDate.setHours(0, 0, 0, 0);
                  filterDate.setHours(0, 0, 0, 0);

                  if (cellDate < filterDate) return -1;
                  if (cellDate > filterDate) return 1;
                  return 0;
                },
            },
        },
        {
            headerName: "Category",
            field: "category",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Priority",
            field: "priority",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Location",
            field: "location_name",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Contact",
            field: "contact_number",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Remark",
            field: "remark",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Village",
            field: "village",
            sortable: true,
            filter: true,
        },
        {
            headerName: "Zone",
            field: "zone",
            sortable: true,
            filter: true,
        },
    ], []);

    const defaultColDef = useMemo(() => {
        return {
            filterParams: {
                buttons: []
            }
        };
    }, []);

    const onGridReady=(params)=>{
        gridRef.current = params.api;
    }

    const onExportClick=()=>{
        if (gridRef.current) {
            gridRef.current.exportDataAsCsv({ fileName: `${title}.csv` });
        }
    }

    const fetchData = async (payload) => {
        setIsLoading(true)
        try {
            setErrors({})
            const response = await Server.get(`/todos/technician?${payload?.technician_id ? `technician_id=${payload.technician_id}` : ""}`)
            setTodos(response?.data)
            setIsLoading(false)
        } catch (error) {
            setIsLoading(false)
            if(error?.response?.status === 401){
                localStorage.removeItem('user')
                navigate('/login')
            }else if (error?.response?.status === 422) {
                setErrors({})
                error?.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error?.response?.status === 403){
                toast.error(error?.response?.data?.detail || 'Forbidden');
                navigate('/');
            }else {
                toast.error(error?.response?.data?.detail || 'Failed to load technician todos')
            }
        }
    }

    const onChange = (e) => {
        const selectedOption = technicainOptions.find(option => option.value === e.target.value);
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))

        if (selectedOption) {
            const date = new Date().toISOString().slice(0, 10)
            setTitle(`${selectedOption.label} - Pending Todos as ${date}`);
        }
    }


    const onSubmit = (e) => {
        e.preventDefault()

        const payload = technician_id !== "" ? {technician_id} : {}
        fetchData(payload)
    }

    const onFirstDataRendered = (params) => {
        params.api.autoSizeAllColumns();
    }

    const onGridSizeChanged = (params) => {
        params.api.autoSizeAllColumns();
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <form onSubmit={onSubmit}>
            <div className="row">
                <div className="col-md-3">
                    <AsyncSelectField
                        name="technician_id"
                        value={technician_id}
                        onChange={onChange}
                        loadOptions={(query) => loadOptions('technicians', query, setTechnicainOptions)}
                        options={technicainOptions}
                        placeholder="Start typing to search..."
                        error={errors.technician_id}
                    />
                </div>
                <div className="col-md-8">
                    <input type="submit" className="btn btn-info mt-1" value="Apply Filter" style={{float: 'left'}}/>
                </div>
                <div className="col-md-1">
                    <button onClick={()=>onExportClick()} className="btn btn-success mb-2" style={{float: 'right'}}><FaFileExport/> &nbsp;Export</button>
                </div>
            </div>
            <br/>
        </form>
        <div className="card">
        <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">{title}</h3>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-md-12">
                        <div className="ag-theme-alpine responsive-aggrid" style={{ height: 400, width: '100%' }}>
                        <AgGridReact
                            suppressMenuHide={true}
                            defaultColDef={defaultColDef}
                            onFirstDataRendered={onFirstDataRendered}
                            onGridSizeChanged={onGridSizeChanged}

                            rowData={todos}
                            domLayout={"normal"}
                            rowSelection={"multiple"}

                            animateRows={true}

                            pagination={false}
                            onGridReady={onGridReady}

                            resizable={true}
                            enableCellTextSelection={true}
                            suppressCellFocus={true}

                            ref={gridRef}
                            columnDefs={columnDefs}
                        ></AgGridReact>{" "}
                    </div>
                    </div>
                </div>
        </div>
        </div>
      <br/>
    </>
  )
}

export default TechnicianTodos